import { useState } from "react";
import { useCreateEsgReport } from "src/classes/PDF/hooks/createEsgReport";
import { ButtonOutline } from "src/components";
import { useResizeObserver } from "src/hooks";

const PrintEsg = ({ finalPercentage, finalScore, orgName }) => {
  const [loading, setLoading] = useState(false);

  const { createEsgReport } = useCreateEsgReport();

  const { width } = useResizeObserver();

  const isMobile = width < 1000;

  if (isMobile) return null;

  const create = async () => {
    setLoading(true);
    try {
      await createEsgReport({
        orgName,
        // reportingPeriod,
        finalPercentage,
        finalScore,
      });
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ButtonOutline disabled={loading} onClick={create}>
      Print report
    </ButtonOutline>
  );
};

export default PrintEsg;
